var _div;
import { Loader } from '@crehana/compass.ui';
import { jsx as _jsx } from "react/jsx-runtime";
var PlayroomHistorySkeleton = function PlayroomHistorySkeleton() {
  return _div || (_div = /*#__PURE__*/_jsx("div", {
    className: "tw-flex tw-justify-center tw-items-center tw-w-full tw-h-full",
    children: /*#__PURE__*/_jsx(Loader, {})
  }));
};
export default PlayroomHistorySkeleton;